import moment from 'moment';
import apiVersion from '../_helpers/api-version';
import queryString from 'query-string';
import axiosInstance from '../_helpers/axiosConfig';

import { store } from '../_helpers/store';
import { authHeader } from "../_helpers/auth-header";
import httpStatus from 'http-status';

export const formService = {
  resend,
  getById,
  sendForm,
  cancelForm,
  getAllForms,
  exportToken,
  rescheduleForm,
  getAllScheduled,
};

function exportToken(searchParams) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/patient-forms/export-token`,
    data: { ...searchParams }
  }).then((response) => {
    return response.data;
  })
}

function resend(appointment, phoneNumber, emailAddress) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/patient-forms/${appointment.id}/resend`,
    data: { phoneNumber, emailAddress }
  }).then((response) => {
    return response.data;
  })
}

function getById(formId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/patient-forms/${formId}`,
  }).then((response) => {
    return response.data;
  })
}

function getAllForms(type) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/forms?type=${type}`,
    headers: authHeader()
  }).then((response) => {
    if (response && response.status === httpStatus.OK) {
      return response.data.data
    }
  });
}

function getAllScheduled(params = {}) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/patient-forms?${queryString.stringify(params)}`,
  }).then((response) => {
    return response.data;
  })
}

function sendForm(form) {
  const clientId = store.getState().client.id;

  const data = { ...form };

  data.emailAddress = form.email;
  data.completeByDate = moment(form.completeByDate).format('YYYY-MM-DD HH:mm');
  data.dateOfBirth = moment(form.dateOfBirth).format('YYYY-MM-DD');
  data.availableOn = form.availableOn ? moment(form.availableOn).format('YYYY-MM-DD HH:mm') : null;

  return axiosInstance.request({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/patient-forms`,
    headers: authHeader(),
    data: data
  })
}

function cancelForm(form) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'DELETE',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/patient-forms/${form.id}`,
  }).then((response) => {
    return response.data;
  })
}

function rescheduleForm(form, date, providerId, locationId, availableOn) {
  const clientId = store.getState().client.id;

  const appointmentDate = moment(date).format('YYYY-MM-DD HH:mm');

  return axiosInstance.request({
    method: 'PATCH',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/patient-forms/${form.id}`,
    data: { appointmentDate, providerId, locationId, availableOn }
  }).then((response) => {
    return response.data;
  })
}